// This browser's chat push subscription (FCommerce_Module_Spec.md 5.4), read and dropped here so the inbox and signing out -
// which runs on every page - share it without pulling the chat API into the storefront's bundle.

/// The server's address for forgetting a browser's subscription (ChatController: api/Chat/Inbox/PushUnsubscribe).
export const CHAT_PUSH_UNSUBSCRIBE = '/api/Chat/Inbox/PushUnsubscribe';

/// What older builds kept once notifications were on, and then hid the offer by for good: read by nothing now, taken away.
const OLD_FLAG = 'chat-push-subscribed';

/// The subscription the chat's worker (registered at '/') holds in this browser, or null: none, or no push here.
export async function chatPushSubscription(): Promise<PushSubscription | null> {
    try {
        if (typeof window === 'undefined' || typeof navigator === 'undefined' || !('serviceWorker' in navigator) || !('PushManager' in window)) { return null; }
        const registration = await navigator.serviceWorker.getRegistration('/');
        return registration && registration.pushManager ? await registration.pushManager.getSubscription() : null;
    } catch {
        return null;
    }
}

/// Notifications off in this browser: `tellServer` is given the endpoint first (while the sign-in still holds), then the
/// browser drops the subscription - so even when the server's word is lost, the push service answers "gone" and the server
/// deletes its row at the next send. Never throws; whether there was one.
export async function dropChatPush(tellServer: (endpoint: string) => Promise<any>): Promise<boolean> {
    try { window.localStorage.removeItem(OLD_FLAG); } catch { }
    const subscription = await chatPushSubscription();
    if (!subscription) { return false; }
    try { await tellServer(subscription.endpoint); } catch { }
    try { await subscription.unsubscribe(); } catch { }
    return true;
}
